import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Modules
import categories from './categories/index'
import user from './user/index'
import cart from './cart/index'
import orders from './orders'
import layout from './layout/index'
import supplierBrand from './supplier/brand'
import supplierCollections from './supplier/collections'
import supplierProducts from './supplier/products'
import supplierStats from './supplier/stats/index'
import supplierStatsSuppliers from './supplier/stats/suppliers'
import supplierStatsBrands from './supplier/stats/brands'
import supplierStatsRetailers from './supplier/stats/retailers'
import supplierMessages from './supplier/messages'
import supplierAccessControl from './supplier/access-control'
import supplierDocs from './supplier/docs'
import supplierOrders from './supplier/orders'
import supplierSets from './supplier/garnitures'
import supplierSet from './supplier/garniture'
import retailerBrand from './retailer/brand'
import retailerProducts from './retailer/products'
import retailerLists from './retailer/lists'
import retailerMessages from './retailer/messages'
import types from './dict/types'
import materials from './dict/materials'
import finenesses from './dict/finenesses'
import colors from './dict/colors'
import technologies from './dict/technologies'
import decor from './dict/decor'
import purposes from './dict/purposes'
import genders from './dict/genders'
import insert from './dict/insert'
import caseShapes from './dict/case-shapes.js'
import other from './dict/other'
import brands from './dict/brands'
import collections from './dict/collections'
import publicStats from './public/stats'
import publicCategories from './public/categories'
import publicItems from './public/items'
import publicBrands from './public/brands'
import publicProducts from './public/products'
import publicLists from './public/lists'
import publicCollections from './public/collections'
import publicCart from './public/cart'
import publicSets from './public/garnitures'
import publicSearch from './public/search'
import retailerSets from './retailer/garnitures'
import help from './user/help'
import invitation from './user/invitation'
import userHamburgerMenu from './user/hamburger-menu'

Vue.use(Vuex)

const mutationsWithoutPersistedState = [
    'user/SET_ERRORS',
    'supplierBrand/SET_ACTIVE_BRAND'
]

export default new Vuex.Store({
    modules: {
        categories,
        user,
        cart,
        orders,
        layout,
        supplierBrand,
        supplierCollections,
        supplierProducts,
        supplierStats,
        supplierStatsSuppliers,
        supplierStatsBrands,
        supplierStatsRetailers,
        supplierMessages,
        supplierAccessControl,
        supplierDocs,
        supplierOrders,
        supplierSets,
        supplierSet,
        retailerBrand,
        retailerProducts,
        retailerLists,
        retailerMessages,
        types,
        materials,
        finenesses,
        colors,
        technologies,
        decor,
        purposes,
        genders,
        insert,
        caseShapes,
        other,
        brands,
        collections,
        publicStats,
        publicCategories,
        publicItems,
        publicBrands,
        publicProducts,
        publicLists,
        publicCollections,
        publicCart,
        publicSets,
        publicSearch,
        retailerSets,
        help,
        invitation,
        userHamburgerMenu
    }
    // plugins: [
    //     createPersistedState({
    //         filter: mutation =>
    //             mutationsWithoutPersistedState.indexOf(mutation.type) === -1
    //     })
    // ]
})
